export const mainColor = "#317BF4";
export const mainBlack = "#080A0A";
export const mainGrey = "#C7C7C7";
export const validationRed = "#CC3131";
export const successGreen = "#269F5A";

export const black = "#414141";

export const red = "#f44336";
